const ITEMS = [
  "916 BIS Hallmark Certified",
  "IGI Certified Diamonds",
  "0% Deduction Gold Exchange",
  "Lifetime Free Maintenance",
  "Insured Home Delivery",
  "Three Decades of Atelier Heritage",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0B1428] py-5">
    <div className="animate-marquee flex w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((t) => (
            <span key={`${t}-${dup}`} className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-[#99732B]">
              <span className="px-10">{t}</span>
              <span className="text-[10px] text-[#D4AF37]">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
